const messages = {
  default: "Something went wrong. Please try again.",
  invalid_promo_code: "Invalid code entered. Please try again.",
  invalid_login: "Invalid login credentials. Please try again.",
  missing_password: "Password can't be blank.",
  missing_email_address: "Email address can't be blank.",
  email_address_exists:
    "Email address already exists. Please login or reset password.",
  missing_mobile_number: "Phone Number can't be blank.",
  invalid_email_address: "Invalid email address. Please try again.",
  promo_code_claimed: "This code has already been claimed.",
  user_periodic_limit:
    "This code has already been used up to its limit for this time period.",
  // Promo Claim Validations
  over_account_rate_limit: "Number of active reservations has been reached.",
  invalid_account: "This parking code is not allowed for this account",
  user_limit:
    "This parking code has been used the maximum number of times by this account",
  promo_limit: "This parking code has been used the maximum number of times",
  invalid_zone: "This parking code cannot be used at this zone",
  invalid_portal: "This parking code cannot be used at this portal",
  invalid_company:
    "This parking code cannot be used at zones operated by this company",
  first_time_only: "This parking code is only for first-time purchases",
  over_allocated_amount: "This parking code has reached is maximum spend limit",
  insufficient_password:
    "Your password must be at least 8 characters long and include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters",
  payment_error: "Could not cancel",
  invalid_transaction: "Invalid Transaction",
  failed_refund: "Failed to refund transaction",
  amount_exceeded_original_amount: "Amount exceeded original transaction",
  cannot_refund_transaction_id_twice: "Transaction already refunded",
  cannot_refund_zero_amount: "Transaction amount is 0, cannot refund",
  invalid_mid_configuration: "Server Error, invalid middle configuration",
  invalid_currency:
    "Transaction currency is invalid, please use same currency as original transaction",
  phone_number_already_verified:
    "Phone number already verified. Please use another phone number.",
  invalid_phone_number: "Invalid phone number. Please try again.",
  phone_change_limit_exceeded:
    "You've reached the limit for phone number changes. Please try again later.",
  invalid_code: "Invalid code. Please try again.",
  verification_expired: "Verification code expired. Please try again.",
  verification_failed: "Verification failed. Please try again.",
  no_pending_verification: "No pending verification. Please try again.",
  found_multiple: "Multiple accounts found. Please login to your account.",
  cooldown_active: "Please wait before requesting another code.",
  client_error: "We're having trouble verifying your code. Please try again.",
  switch_limit_exceeded:
    "You have reached the maximum number of phone number changes for this session.",
  turnstile_verification_failed: "Verification failed. Please try again.",
  turnstile_invalid: "Invalid verification. Please refresh and try again.",
  rate_limit_exceeded:
    "You have reached the maximum number of requests. Please try again later.",
  cf_token_invalid: "Please verify you are human."
}

const proxyHandler = {
  get: (obj, prop) => {
    return prop in obj ? obj[prop] : obj.default
  }
}

export const errorMessages = new Proxy(messages, proxyHandler)
